<div class="card">
  <div class="card-body">
    <div class="d-flex">
      <div>
        <h3 class="card-title m-b-5" style="color: black;font-weight: bold;">
          <span class="lstick"></span>Quick Actions
        </h3>
      </div>
    </div>
    <div class="text-center" >
      <ul class="list-group list-group-flush ">
        <li class="list-group-item "  (click)="openAddDialog()">Add Units</li>
        <!-- <li class="list-group-item"   (click)="openProvisionDIalog()">Provision units</li>
        <li class="list-group-item"   (click)="openMonitorDialog()">Monitor units</li> -->
        <li class="list-group-item"   (click)="openBulkActionsDialog()">Bulk Management</li>
        <li class="list-group-item"   (click)="openWallpaperUploadActionDialog()">Push Wallpaper</li>
        <li class="list-group-item"   (click)="openConfirmationDialogForPhonebookRefresh()">Refresh Phonebook</li>

        <!-- <li class="list-group-item"   (click)="openConfirmationDialog()">Pull all units' configurations</li> -->
      </ul>
    </div>
  </div>
</div>
